<nav class="navbar navbar-expand nav-wrapper py-0"  *ngIf="headerdata?.length" [ngClass]="themeClass('navbar-wrapper-section1')" >
  <div class="container container-wider">
    <button class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ">

        <li class="menu-nav-item dropdown has-subcat"  *ngFor="let item of headerdata; let i = index">
          <a class="nav-link"
             role="button"
             data-bs-toggle="dropdown" *ngIf="item.menu_name =='Shop By Vehicle'" (click)="openVechiclePopup()" >
          {{item.menu_name}}
          </a>
          <a class="nav-link"
             role="button"
             data-bs-toggle="dropdown"  [routerLink]="item.menu_link" *ngIf="item.menu_name !='Shop By Vehicle'" >
          {{item.menu_name}}
          </a>
          <ul class="dropdown-menu"  *ngIf="item.load_child_menus?.length">
            <li class="submenu"*ngFor="let child of item.load_child_menus "><a class="sub-cat"  [routerLink]="child.menu_link" role="button"
             data-bs-toggle="dropdown">{{child.menu_name}}</a>
             <!-- for child child category -->
             <!-- <ul class="dropdown-menu submenu-dropdown has-subcat">
            <li class="submenu"><a class="sub-cat" href="#" role="button"
             data-bs-toggle="dropdown">engine 1</a></li>
            <li><a class="sub-cat" href="#">engine 2</a></li>
          </ul> -->
            </li>
          </ul>
          <ul class="dropdown-menu py-0"  *ngIf="item.category_children?.length">
            <app-header-cascading-link *ngFor="let cat of item.category_children" [flip]="getFlip(item.category_children,i)" [subCategories]="cat" />
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>

